require("@babel/polyfill");
require("./page.scss");

(function () {

})();